export const CHARACTER_LIMIT = 200;